module.exports = __webpack_public_path__ + "img/logo.7971e4d1.png";